import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export function ProMap({ professionals }) {
    const containerRef = useRef(null);
    const mapRef = useRef(null);
    const layerRef = useRef(null);

    useEffect(() => {
        if (mapRef.current) return;
        mapRef.current = L.map(containerRef.current, { scrollWheelZoom: false }).setView([42.5, 12.5], 5);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap",
            maxZoom: 18,
        }).addTo(mapRef.current);
        layerRef.current = L.layerGroup().addTo(mapRef.current);
        return () => {
            mapRef.current?.remove();
            mapRef.current = null;
        };
    }, []);

    useEffect(() => {
        if (!mapRef.current || !layerRef.current) return;
        layerRef.current.clearLayers();
        const pts = professionals.filter((p) => p.lat != null && p.lng != null);
        const pinHtml = (verified) => `
            <div style="position:relative;width:30px;height:30px">
              <div style="width:30px;height:30px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${verified ? "#1A2E25" : "#C25E3B"};border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.3)"></div>
            </div>`;
        pts.forEach((p) => {
            const icon = L.divIcon({ className: "fipro-pin", html: pinHtml(p.verified), iconSize: [30, 30], iconAnchor: [15, 30], popupAnchor: [0, -28] });
            const marker = L.marker([p.lat, p.lng], { icon }).addTo(layerRef.current);
            const rating = p.rating != null ? `⭐ ${p.rating} (${p.reviews_count})` : "Nuovo";
            marker.bindPopup(`
                <div style="font-family:Outfit,sans-serif;min-width:170px">
                  <div style="font-weight:700;color:#1A2E25;font-size:15px">${p.name}</div>
                  <div style="color:#C25E3B;font-size:13px;margin:2px 0">${p.category_name} · ${p.city}</div>
                  <div style="font-size:12px;color:#555">${rating} · ${p.currency_symbol || "€"}${p.hourly_rate}/h</div>
                  <a href="/professionista/${p.id}" style="display:inline-block;margin-top:8px;background:#1A2E25;color:#fff;padding:6px 12px;border-radius:999px;font-size:12px;text-decoration:none;font-weight:600">Vedi profilo</a>
                </div>`);
        });
        if (pts.length) {
            const bounds = L.latLngBounds(pts.map((p) => [p.lat, p.lng]));
            mapRef.current.fitBounds(bounds.pad(0.3), { maxZoom: 12 });
        }
    }, [professionals]);

    return <div ref={containerRef} className="w-full h-[600px] rounded-2xl overflow-hidden border border-border z-0" data-testid="pro-map" />;
}
